<template>
  <div
    class="text-wrap d-flex py-4 px-3"
    style="cursor: pointer; position: relative"
    @click="handleDocumentInfoClick"
  >
    <div class="card-content">
      <div v-if="type == 'abn_acn'">
        <h5>ABN/ACN</h5>
        <ul>
            <li>
                <span class="title">Company Name:</span>
                <span class="sub-title">{{ cardData.company_name }}</span>
            </li>

            <li>
                <span class="title">ABN/ACN:</span>
                <span class="sub-title">{{ cardData.abn_acn }} </span>
            </li>
        </ul>
        <SvgIcons
          v-if="cardData.abn_acn_status == 'verified'"
          icon="icon-verified"
          width="75"
          height="75"
          svgClass="mb-1 ml-5 pull-right"
          style="position: absolute; top: 20px; right: -18px;"
        />
        <SvgIcons
          v-else
          icon="icon-error"
          width="45"
          height="55"
          svgClass="mb-1 mr-4 pull-right"
          style="position: absolute; top: 20px; right: -18px;"
        />
      </div>

      <div v-if="type == 'license'" class="contractor-licence">
        <h5>Contractor Licence</h5>
        <div
          v-for="(license, index) in cardData.license"
          :key="index"
          class="row"
        >

          <div class="col-md-12">
          <!-- type -->
            <ul v-if="license.licence_type">
                <li>
                    <span class="title">Type:</span>
                    <span class="sub-title">
                        <span v-if="license.licence_type == 'trade_work'">Trade Work</span>
                        <span v-if="license.licence_type == 'security'">Master Licence</span>
                        <span v-if="license.licence_type == 'asbestos_and_high_risk'">Asbestos & High Risk</span>
                        <span v-if="license.licence_type == 'pesticide'">Pesticide licence and permit</span>
                        <span v-if="license.licence_type == 'fire_and_safety'">FPAA Accreditation</span>
                        <span v-if="license.licence_type == 'other'">Other</span>
                    </span>
                </li>
            </ul>

            <!-- licence -->
            <ul v-if="license.licence_number">
                <li>
                    <span class="title">Licence No:</span>
                    <span class="sub-title">{{ license.licence_number }}</span>
                </li>
            </ul>
          </div>
        </div>
        <i
        v-if="isAllLicensesVerified=='expired'"
         class="fas fa-check-circle"
         style="font-size: 20px;  color: rgb(255, 234, 0); position: absolute; top: 20px; right: 20px; "
        ></i>
        <SvgIcons
          v-else-if="isAllLicensesVerified=='verified'"
          icon="icon-verified"
          width="45"
          height="55"
          svgClass="mb-1 mr-4 pull-right"
          style="position: absolute; top: 20px; right: -18px"
        />
        <i
        v-else-if="isAllLicensesVerified=='blocked'"
         class="fas fa-check-circle"
         style="font-size: 20px; color: rgb(255, 87, 51); position: absolute; top: 20px; right: 20px; "
        ></i>
        <SvgIcons
          v-else
          icon="icon-error"
          width="45"
          height="55"
          svgClass="mb-1 mr-4 pull-right"
          style="position: absolute; top: 20px; right: -18px"
        />
      </div>

      <div v-if="type == 'insurance'">
        <h5>Business Insurance</h5>
        <div
          v-for="(insurance, index) in cardData.insurances"
          :key="index"
          class="row insurance-box"
        >
          <div class="col-md-12">
            <ul>
                <li>
                    <span class="title">Type:</span>
                    <span class="sub-title">
                        <span v-if="insurance.insurance_type == 'public-liability'">Public Liability</span>
                        <span v-if="insurance.insurance_type == 'workers-compensation'">Workers Compensation</span>
                        <span v-if="insurance.insurance_type == 'professional-indemnity'">Professional Indemnity</span>
                        <span v-if="insurance.insurance_type == 'other-insurances'">Other Insurance</span>
                    </span>
                </li>

                <!-- policy -->
                <li>
                    <span class="title">Policy No: </span>
                    <span class="sub-title">
                        <span v-if="insurance.insurance_policy">
                            {{ insurance.insurance_policy }}</span>
                    </span>
                </li>

                <!-- limit -->
                <li>
                    <span class="title">Limit($):</span>
                    <span class="sub-title">
                        <span v-if="insurance.insurance_limit">
                            {{ insurance.insurance_limit.toLocaleString() }}</span>
                        </span>
                </li>

                <!-- Expiry -->
                <li>
                    <span class="title">Expiry:</span>
                    <span class="sub-title">
                        <span v-if="insurance.insurance_expiry">
                            {{ momentDate(insurance.insurance_expiry) }}
                        </span>
                    </span>
                </li>
            </ul>
          </div>
        </div>
        <i
        v-if="isAllInsuranceVerified=='expired'"
         class="fas fa-check-circle"
         style="font-size: 20px;  color: rgb(255, 234, 0); position: absolute; top: 20px; right: 20px; "
        ></i>
        <SvgIcons
          v-else-if="isAllInsuranceVerified=='verified'"
          icon="icon-verified"
          width="45"
          height="55"
          svgClass="mb-1 mr-4 pull-right"
          style="position: absolute; top: 20px; right: -18px"
        />
        <i
        v-else-if="isAllInsuranceVerified=='blocked'"
         class="fas fa-check-circle"
         style="font-size: 20px; color: rgb(255, 87, 51); position: absolute; top: 20px; right: 20px; "
        ></i>
        <SvgIcons
          v-else
          icon="icon-error"
          width="45"
          height="55"
          svgClass="mb-1 mr-4 pull-right"
          style="position: absolute; top: 20px; right: -18px"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcons from "@frontend/pages/includes/SvgIconsComponent.vue";
import moment from "moment";

export default {
  props: {
    type: String,
    cardData: Object,
  },
  components: {
    SvgIcons,
    moment,
  },
  data() {
    return {
        Status: 'verified',
        insuranceStatus: 'verified'
    };
  },
  mounted() {},
  computed: {
    isAllLicensesVerified() {
      if (this.cardData.license.length <= 0) {
        this.Status= 'blocked';
      }
      else{
        this.Status='verified';
        let current_date= new Date().getTime();
        let passed_days= 0;
        this.cardData.license.forEach((license)=>{
            if(this.Status!='blocked' && this.Status!='expired'){
             if(license.licence_status=='verified' && this.cardData.compliant_status_note!='exempt'){
                let remaining_days=  Math.ceil((new Date(license.expiry_date).getTime()- current_date)/ (1000 * 3600 * 24)) ;
                 if(remaining_days<= 0){
                    passed_days= Math.ceil((current_date - new Date(license.expiry_date).getTime())/ (1000 * 3600 * 24));
                    if(passed_days <= 15){
                        this.Status= 'blocked'
                    }
                    else{
                        this.Status= 'hide'
                    }
                 }
                 else if(remaining_days<=7 && remaining_days>=0 ){
                     this.Status= 'expired';
                 }

              }
            }
              else if(license.licence_status!='verified'){
                this.Status= 'hide';
              }
        })

      }
      return this.Status;
    },
    isAllInsuranceVerified() {
      if (this.cardData.insurances.length <= 0) {
        this.insuranceStatus= 'blocked';
      }
      else{
        this.insuranceStatus='verified';
        let current_date= new Date().getTime();
        let passed_days= 0;
        this.cardData.insurances.forEach((insurance)=>{
            if(this.insuranceStatus!='blocked' && this.insuranceStatus!='expired'){
             if(insurance.insurance_status=='verified' && this.cardData.compliant_status_note!='exempt'){
                let remaining_days=  Math.ceil((new Date(insurance.insurance_expiry).getTime()- current_date)/ (1000 * 3600 * 24)) ;
                 if(remaining_days<= 0){
                    passed_days= Math.ceil((current_date - new Date(insurance.insurance_expiry).getTime())/ (1000 * 3600 * 24));
                    if(passed_days <= 15){
                        this.insuranceStatus= 'blocked'
                    }
                    else{
                        this.insuranceStatus= 'hide'
                    }
                 }
                 else if(remaining_days<=7 && remaining_days>=0 ){
                     this.insuranceStatus= 'expired';
                 }

              }
            }
              else if(insurance.insurance_status!='verified'){
                this.insuranceStatus= 'hide';
              }
        })

      }
      return this.insuranceStatus;
    },
  },
  methods: {
    handleDocumentInfoClick() {
      this.$router.push({
        name: "contractor-compliance-sub-page",
        params: { subPage: this.type },
      });
    },
    momentDate: function (date) {
      return moment(date).format("D MMM YYYY");
    },
  },
};
</script>
